import React, { useEffect } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";

import { fetchBrancheById, fetchBranches } from "../../modules/attendanceUnits";
import { convertRichUnitToUnit, RichUnit } from "../../models/AttendanceUnit";
import { UnitInfoProps } from "../../models/UnitInfo";

import Units from "./components/Units";
import EinsteinScheduling from "./components/EinsteinScheduling";
import CareTeam from "./components/CareTeam";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

import * as S from "./styles";
import Vaccine from "./components/Vaccine";
import { Unit } from "../../models/Unit";
import { checkQueryParamName, getQueryParamValue } from "../../utils/location";
import FindYourDoctor from "./components/FindYourDoctor";
import { SchedulerItem } from "@einstein/schedule-platform";
import { showFindYourDoctorSection } from "../../utils/feattureFlag";
import {
  turnHiddenOverflow,
  turnInitialOverflow,
} from "../../utils/overflowDOM";
import { firebaseOptions } from "../../utils/envs";

export const TemplateBody = styled.div`
  width: 100%;
  padding-top: 72px;
`;

enum RouterModule {
  PRODUCT = "PRODUCT",
  SERVICE = "SERVICE",
  CONSULTAPPOINTMENT = "CONSULTAPPOINTMENT",
  UNIT = "UNIT",
  SPECIALIST = "SPECIALIST",
}

const Home = () => {
  const [isSchedulerOpen, setIsSchedulerOpen] = React.useState(false);
  const [patient, setPatient] = React.useState();
  const [specialistNameLink, setSpecialistNameLink] = React.useState<string>();

  const [routerTo, setRouterTo] = React.useState<
    keyof typeof RouterModule | undefined
  >();
  const [units, setUnits] = React.useState<Unit[] | undefined>([]);
  const [selectedUnit, setSelectedUnit] = React.useState<UnitInfoProps>();
  const [serviceIdSelected, setServiceIdSelected] = React.useState("");

  function checkUnitTypeToShow(unitID: string) {
    const unitsShow = process.env.REACT_APP_UNITS_SHOW?.split(",");
    return !!unitsShow?.find((item) => item === unitID);
  }

  const getAttendanceUnits = async () => {
    const response = await fetchBranches(100);
    const richUnits: Unit[] = [];
    response.map((richUnit: RichUnit) => {
      if (checkUnitTypeToShow(richUnit.business_unit_type?.id || ""))
        richUnits.push(convertRichUnitToUnit(richUnit));
      return undefined;
    });

    setUnits(richUnits);
  };

  useEffect(() => {
    getAttendanceUnits();
    const EINSTEIN_DOCTORS = getQueryParamValue("medicos_einstein");

    if (EINSTEIN_DOCTORS === "1" || EINSTEIN_DOCTORS === "true") {
      window.location.href = `#encontre-seu-medico`;
      setRouterTo(RouterModule.SPECIALIST);
      setIsSchedulerOpen(true);
    } else if (EINSTEIN_DOCTORS && EINSTEIN_DOCTORS?.length > 1)
      setSpecialistNameLink(EINSTEIN_DOCTORS);

    if (checkQueryParamName("banco_de_sangue")) {
      setServiceIdSelected(process.env.REACT_APP_BLOOD_BANK_SERVICE_ID || "");
      setRouterTo(undefined);
      setIsSchedulerOpen(true);
    }
    //REACT_APP_BLOOD_BANK_SERVICE_ID
  }, []);

  const handleStoragePatient = () => {
    const localPatient = window.localStorage.getItem("patient");
    if (localPatient) {
      const patient = JSON.parse(localPatient);
      console.log(
        "🚀 ~ file: ScheduleItem.tsx:145 ~ handleStoragePatient ~ patient:",
        patient
      );

      if (patient.name && patient.email && patient.document) {
        setPatient(patient);
        // setPatientSelected(patient);
      }
    }
  };

  React.useEffect(() => {
    handleStoragePatient();
  }, []);

  const handleOpenUnitInfo = async (unit: Unit) => {
    const response = await fetchBrancheById(unit.id);
    if (response) {
      setSelectedUnit(response);

      setRouterTo(RouterModule.UNIT);
      setIsSchedulerOpen(true);
    } else {
      toast.error("Ocorreu um erro, tente novamente");
    }
  };

  function openScheduleSidebar() {
    setIsSchedulerOpen(true);
    // toogleOverflow();
  }

  React.useEffect(() => {
    if (isSchedulerOpen) turnHiddenOverflow();
    else turnInitialOverflow();
  }, [isSchedulerOpen]);

  return (
    <>
      <Navbar
        onOpenConsultSchedule={() => {
          openScheduleSidebar();
          setRouterTo(RouterModule.CONSULTAPPOINTMENT);
        }}
      />
      <TemplateBody>
        <S.Body>
          <EinsteinScheduling
            handleSchedule={() => {
              openScheduleSidebar();
              setRouterTo(undefined);
            }}
            hasProductError={false}
          />
          {showFindYourDoctorSection() ? (
            <FindYourDoctor
              handleSchedule={() => {
                openScheduleSidebar();
                setRouterTo(RouterModule.SPECIALIST);
              }}
              hasProductError={false}
            />
          ) : null}
          <CareTeam
            handleSchedule={() => {
              openScheduleSidebar();
              setRouterTo(RouterModule.SERVICE);
            }}
          />
          <Vaccine
            handleSchedule={() => {
              openScheduleSidebar();
              setRouterTo(RouterModule.PRODUCT);
            }}
          />
          <Units listUnits={units} onClickSeeDetails={handleOpenUnitInfo} />
          <SchedulerItem
            visible={isSchedulerOpen}
            onClose={() => setIsSchedulerOpen(false)}
            routerTo={routerTo}
            unit={selectedUnit}
            selectedServiceId={serviceIdSelected}
            specialistNameToOpen={specialistNameLink}
            firebaseOptions={firebaseOptions.appId ? firebaseOptions : undefined}
          />
        </S.Body>
        <Footer />
      </TemplateBody>
    </>
  );
};

export default Home;
